import zod from 'zod';
import { stringToBoolean, stringToListOfNumber, zodLimit, zodPage } from './helpers';
import { cameraTypes, storageTypes } from './cameras';

export const manufacturers = [
    'hikvision',
    'dahua',
    'intelbras'
] as const;
export type Manufacturer = typeof manufacturers[number];

export const CrmSchemas = {
    Management: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        offline: stringToBoolean.optional(),
        tagsIds: stringToListOfNumber.optional(),
        type: zod.enum(cameraTypes).optional(),
        manufacturer: zod.enum(manufacturers).optional(),
        installationCompanyId: zod.coerce.number().optional(),
        internetCompanyId: zod.coerce.number().optional(),
        hasFacial: stringToBoolean.optional(),
        hasLpr: stringToBoolean.optional(),
        hasAreaInvasion: stringToBoolean.optional(),
        storageType: zod.enum(storageTypes).optional(),
        companyId: zod.coerce.number().optional(),
        serverId: zod.coerce.number().optional(),
    }),
    ManagementDetails: zod.object({
        id: zod.string().optional(),
    }),
    AlarmCentersList: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    AlarmCenterDetails: zod.object({
        id: zod.string().optional(),
    }),
    OfflineEvents: zod.object({
        id: zod.undefined(),
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        fromDuration: zod.coerce.number().optional(),
        toDuration: zod.coerce.number().optional(),
        onlyOffline: stringToBoolean,
        fromStart: zod.coerce.number().optional(),
        toStart: zod.coerce.number().optional(),
        fromFinish: zod.coerce.number().optional(),
        toFinish: zod.coerce.number().optional(),
        polygonType: zod.string().optional(),
        polygon: zod.coerce.number().optional(),
        orderBy: zod.string().optional(),
        orderDirection: zod.enum(['asc', 'desc']),
    }),
    CameraHistory: zod.object({
        id: zod.string().optional(),
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        fromDuration: zod.coerce.number().optional(),
        toDuration: zod.coerce.number().optional(),
        onlyOffline: stringToBoolean,
        fromStart: zod.coerce.number().optional(),
        toStart: zod.coerce.number().optional(),
        fromFinish: zod.coerce.number().optional(),
        toFinish: zod.coerce.number().optional(),
        polygonType: zod.string().optional(),
        polygon: zod.coerce.number().optional(),
        orderBy: zod.string().optional(),
        orderDirection: zod.enum(['asc', 'desc']),
    }),
    TicketReasons: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    OfflineEventsKanban: zod.object({
        companyId: zod.coerce.number().optional(),
    }),
    MaintenanceRequests: zod.object({
        textFilter: zod.string().optional(),
    }),
    TicketDetail: zod.object({
        id: zod.coerce.number(),
    }),
    TicketCameraDetail: zod.object({
        id: zod.coerce.number(),
    }),
    KanbanTicketDetail: zod.object({
        id: zod.coerce.number(),
    }),
};
